import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { OrderRateReasonMiniEntity } from '../../domain/entities/OrderRateReasonMiniEntity'

export class OrderRateReasonMiniModel extends OrderRateReasonMiniEntity {
  constructor(dataDto: OrderRateReasonMiniEntity) {
    super()
    mapEntityProperties<OrderRateReasonMiniModel>(this, dataDto)
  }
}
